module.exports = __webpack_public_path__ + "img/Antibiotic Sensitivity Discs.2.81ad5ee2.jpg";